import {Component, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';
import {AppComponent} from '../app.component';
import {MatDialog} from '@angular/material';
import {FacebookService, UIParams, UIResponse} from 'ngx-facebook';
import swal from 'sweetalert2';
import {ViewUserComponent} from '../view-user/view-user.component';
import {EditSuggestionComponent} from '../edit-suggestion/edit-suggestion.component';
import {Router} from '@angular/router';
import {FileUploadService} from '../services/FileUploadService';

declare var $;

@Component({
    selector: 'app-sub-brands',
    templateUrl: './sub-brands.component.html',
    styleUrls: ['./sub-brands.component.css'],
    providers: [HttpService, NotificationService, FileUploadService]
})
export class SubBrandsComponent implements OnInit {

    public apiUrl = environment.apiUrl;

    public showAddModalBool = false;

    public addBrandData = {
        name: '',
        type: 'child',
        image_path: '',
        parent_id: 0
    }


    public imagesToShow;

    public allBrands;

    public sortValue: string = '';

    public showImagesModalBool = false;

    public parentBrandData;

    public User_Details: any;
    public allSuggestions;

    public showType: string = 'suggestions';

    public isBrandParent = false;

    public brandToShowSuggestionsFor;

    public brandOptions = [];
    public filterOptions = {
        brand: 0
    }

    public reverse: boolean = false;

    constructor(
        public http: HttpService,
        public notification: NotificationService,
        public app: AppComponent,
        public dialog: MatDialog,
        private fb: FacebookService,
        public router: Router,
        public fileUpload: FileUploadService,
    ) {


    }

    ngOnInit() {

        this.isBrandParent = false;


        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        if (this.User_Details.role.id == 1) {
            this.app.loading = true;
            this.http.makeRequestPost([
                'admin/user/suggestion/getallsuggestions',
                {
                    token: this.User_Details.token
                }
            ])
            .subscribe(
                (response) => {
                    this.app.loading = false;
                    if (response.data) {
                        this.allSuggestions = response.data.suggestions;


                        this.brandOptions = response.data.brands;
                        this.brandOptions.unshift({name: 'All', id: 0});
                    }
                    if (response.error) {
                        this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                    }
                },
                (error) => {
                    this.app.loading = false;
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            )
        } else {

            this.app.loading = true;
            this.http.makeRequestPost([
                'brand/admin/suggestion/get',
                {
                    token: this.User_Details.token,
                    id: this.User_Details.brandadmins[0].id
                }
            ])
            .subscribe(
                (response) => {
                    this.app.loading = false;
                    if (response.data) {
                        this.allSuggestions = response.data.suggestions;
                        this.brandOptions = response.data.brands;
                        this.brandOptions.unshift({name: 'All', id: 0});
                        if (this.allSuggestions.length > 0) {
                            if (this.allSuggestions[0].brand[0].is_parent == 1) {
                                this.isBrandParent = true;
                            } else {
                                this.isBrandParent = false;
                            }
                            console.log(this.isBrandParent);
                        }

                        if (this.isBrandParent) {
                            this.app.loading = true;

                            this.http.makeRequestPost(['app/user/brands/getbrandchildren', {id: this.isBrandParent = this.allSuggestions[0].brand[0].id}])
                            .subscribe(
                                (respBrands) => {
                                    console.log(respBrands);
                                    this.app.loading = false;
                                    if (respBrands.data.allbrands) {
                                        this.allBrands = respBrands.data.allbrands;
                                        this.parentBrandData = respBrands.data.brand
                                    } else {
                                        this.notification.showNotification('Could not get all the brand children', 'Error', 'error');
                                    }
                                },
                                (error) => {
                                    this.notification.showNotification('Could not get all the brand children', 'Error', 'error');
                                    this.app.loading = false;
                                    console.log(error);
                                }
                            )
                        }
                    }
                    if (response.error) {
                        this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                    }
                },
                (error) => {
                    this.app.loading = false;
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            )
        }

    }

    markNotAbusive(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to mark this suggestion as not abusive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/markNotAbusive',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.reported == 0 && resp.data.abusive == 0) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }
                                this.notification.showNotification('The suggestion has been marked as not abusive', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not mark the suggestion as not abusive', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    markAbusive(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to mark this suggestion as abusive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/markAbusive',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.reported == 1 && resp.data.abusive == 1) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }
                                this.notification.showNotification('The suggestion has been marked as abusive', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not mark the suggestion as abusive', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    showUserDetails(user) {
        console.log(user);

        let dialogRef = this.dialog.open(ViewUserComponent, {
            width: '100vw',
            height: '100vh',
            data: {userDetails: user}
        });

        dialogRef.afterClosed().subscribe((result) => {


        });

    }


    reportSuggestion(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to report this suggestion as abusive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['brand/admin/suggestion/report',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.reported == 1) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }

                                this.notification.showNotification('The suggestion has been reported', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not report the suggestion', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    rewardSuggestion(suggestion) {
        console.log('rewardSuggestion called');
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to reward the user for this suggestion?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/awesome_award.svg',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['brand/admin/suggestion/reward',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.rewarded == 1) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }
                                swal({
                                    title: "You've awarded  " + resp.data.user[0].name + "." ,
                                    text: 'Please contact ' + resp.data.user[0].name + ' directly on ' + resp.data.user[0].email + ' to reward them. ',
                                    type: 'warning',
                                    showCancelButton: false,
                                    confirmButtonText: 'Ok',
                                    buttonsStyling: false,
                                    imageUrl: 'assets/img/Popup_Squirrel.png',
                                    imageWidth: 100,
                                    showCloseButton: false,
                                    animation: false,
                                    confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
                                    cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
                                    reverseButtons: false
                                }).then((data) => {
                                    if (data.value) {
                                        swal({
                                            title: 'Share?',
                                            text: 'Would you like to share this on your brand Facebook page?',
                                            type: 'warning',
                                            showCancelButton: true,
                                            confirmButtonText: 'Yes',
                                            buttonsStyling: false,
                                            imageUrl: 'assets/img/Popup_Squirrel.png',
                                            imageWidth: 100,
                                            showCloseButton: true,
                                            animation: false,
                                            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
                                            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
                                            reverseButtons: true
                                        }).then((data) => {
                                            if (data.value) {
                                                if (suggestion.photos.length > 0) {
                                                    const options: UIParams = {
                                                        method: 'share',
                                                        quote: suggestion.user[0].name + ' ' + suggestion.user[0].surname + ' ' + 'has been rewarded for their suggestion: ' + suggestion.description + ' to the brand: ' + suggestion.brand[0].name + ' @[{10216349012700562}:{xander hattingh}]',
                                                        href: environment.apiUrl + 'get_image/' + suggestion.photos[0].image_path,
                                                    };
                                                    this.fb.ui(options)
                                                    .then(
                                                        (res: UIResponse) => {
                                                            console.log('Got the users profile', res);
                                                        })
                                                    .catch((error) => {
                                                        this.notification.showNotification('Unable to share', 'Error', 'error');
                                                    });
                                                } else {
                                                    const options: UIParams = {
                                                        method: 'share',
                                                        quote: suggestion.user[0].name + ' ' + suggestion.user[0].surname + ' ' + 'has been rewarded for their suggestion: ' + suggestion.description + ' to the brand: ' + suggestion.brand[0].name + ' @[{10216349012700562}:{xander hattingh}]',
                                                        href: environment.apiUrl + 'get_image/suggestion.jpg',
                                                    };
                                                    this.fb.ui(options)
                                                    .then(
                                                        (res: UIResponse) => {
                                                            console.log('Got the users profile', res);
                                                        })
                                                    .catch((error) => {
                                                        this.notification.showNotification('Unable to share', 'Error', 'error');
                                                    });
                                                }
                                            }
                                        }).catch(swal.noop);
        
                                        this.notification.showNotification('The user has been rewarded', 'Success', 'success');
                                    }
                                }).catch(swal.noop);

                                this.notification.showNotification('The user has been rewarded', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not reward the user for the suggestion', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        })

    }

    editSuggestion(suggestion) {
        let dialogRef = this.dialog.open(EditSuggestionComponent, {
            width: '100vw',
            data: {suggestionDetails: suggestion, allBrands: this.brandOptions}
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (result.changedSuggestion) {
                    for (var i = 0; i < this.allSuggestions.length; i++) {
                        if (this.allSuggestions[i].id == suggestion.id) {
                            this.allSuggestions[i] = result.changedSuggestion;
                        }
                    }
                }
            }

        });
    }

    deleteSuggestion(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to delete this suggestion?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {
                console.log('delete the suggestion');
                console.log(suggestion);
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/delete', {token: this.User_Details.token, id: suggestion.id}])
                .subscribe(
                    (response) => {
                        this.app.loading = false;
                        if (response.data) {
                            if (response.data.length != 0) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions.splice(i, 1);
                                    }
                                }
                            } else {
                                this.notification.showNotification('Could not delete the suggestion', 'Error', 'error');
                            }
                        }
                        if (response.error) {
                            this.notification.showNotification('Could not delete the suggestion', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }

        })
    }

    setShowType(value: string) {
        console.log(value);
        this.showType = value;
    }

    onLinkClick(evt) {
        console.log(evt.tab.textLabel.toLowerCase());
        this.showType = evt.tab.textLabel.toLowerCase();
        // .textLabel.toLowerCase()
        // this.showType = value;
    }


    showImagesModal(photos) {
        this.showImagesModalBool = true;
        this.imagesToShow = photos;
    }

    toggleShowOptions(suggestion) {
        if (suggestion.showOptions == true) {
            suggestion.showOptions = false;
        } else {
            for (var i = 0; i < this.allSuggestions.length; i++) {
                this.allSuggestions[i].showOptions = false;
            }

            suggestion.showOptions = true;
        }
    }

    toggleBrandParentOptions(brand) {
        if (brand.showParentOptions == true) {
            brand.showParentOptions = false;
        } else {
            for (var i = 0; i < this.allBrands.length; i++) {
                this.allBrands[i].showParentOptions = false;
            }

            brand.showParentOptions = true;
        }
    }

    showBrandSuggestions(brand) {
        this.app.loading = true;
        this.http.makeRequestPost([
            'brand/admin/suggestion/get',
            {
                token: this.User_Details.token,
                id: brand.id
            }
        ])
        .subscribe(
            (response) => {
                this.app.loading = false;
                if (response.data) {
                    this.allSuggestions = response.data.suggestions;
                    this.brandToShowSuggestionsFor = brand;
                    brand.showOptions = false;
                }
                if (response.error) {
                    this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    showChildBrands() {
        delete (this.brandToShowSuggestionsFor);
    }


    setTypeToShow(evt) {
        console.log(evt);
    }

    checkShowBrand(brand, option) {
        if (brand.id == option.id) {
            return false;
        }

        if (option.parent_id != null) {
            return false;
        }

        return true;
    }

    onDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
        console.log(event.dataTransfer.files);
        this.uploadFile(event.dataTransfer.files);
        // your code goes here after droping files or any
    }

    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();

    }

    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();

    }

    fileChange(event) {
        const selected = event.target.files && event.target.files[0];
        if (!this.fileUpload.isValidImageFile(selected)) {
            this.notification.showNotification('Please select an image file (JPG or PNG).', 'Invalid file', 'error');
            event.target.value = '';
            return;
        }
        this.uploadFile(event.target.files);
    }

    uploadFile(file) {
        console.log(file);
        this.app.loading = true;

        this.fileUpload.uploadFile('app/user/brands/upload_brand_image', file, {})
        .subscribe(
            (response) => {
                console.log(response);

                setTimeout(() => {

                    this.addBrandData.image_path = response.data;

                    this.app.loading = false;
                }, 1000);


            },
            (error) => {
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                this.app.loading = false;
            }
        );
    }

    setAddBrandType(type, evt) {
        if (type == 'parent') {
            if (evt.checked == true) {
                this.addBrandData.type = 'parent'
            } else {
                this.addBrandData.type = 'child'
            }
        }

        if (type == 'child') {
            if (evt.checked == true) {
                this.addBrandData.type = 'child'
            } else {
                this.addBrandData.type = 'parent'
            }
        }
    }

    toggleAddModal() {
        if (this.showAddModalBool == true) {
            $('.wrapper').removeClass('lock-scroll');
        } else {
            $('.wrapper').addClass('lock-scroll');
        }
        this.showAddModalBool = !this.showAddModalBool;

    }

    addBrand() {
        this.app.loading = true;
        console.log(this.allBrands);
        this.http.makeRequestPost(['app/user/brands/add_brand', {
            token: this.User_Details.token,
            name: this.addBrandData.name,
            type: this.addBrandData.type,
            image_path: this.addBrandData.image_path,
            parent_id: this.parentBrandData.id,
        }])
        .subscribe(
            (response) => {
                this.app.loading = false;
                if (response.data) {
                    this.allBrands.unshift(response.data);
                    console.log(this.allBrands);
                    this.toggleAddModal();
                    this.addBrandData = {
                        name: '',
                        type: 'parent',
                        image_path: '',
                        parent_id: 0
                    }

                }
                if (response.error) {
                    if (response.error.indexOf('Login session expired') > -1) {
                        this.notification.showNotification('Login session expired, please log in and try again', 'Error', 'error');
                        this.router.navigate(['/pages/login']);

                    } else {
                        this.notification.showNotification('Could not create the new brand', 'Error', 'error');
                    }

                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

}



// WEBPACK FOOTER //
// ./src/app/sub-brands/sub-brands.component.ts